<ng-content></ng-content>
<input type="file"
       class="fill cursor-pointer"
       [attr.accept]="accept"
       (change)="onChange($event)" />